module.exports = __webpack_public_path__ + "static/media/21.3782d7fa.mp3";